export default __webpack_public_path__ + "static/media/magento.031c3c4f.svg";